import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import React, { useState } from "react"

import { UserPoints } from "./UserPoints"
import { auth } from "../firebase"
import { getLocationStr } from "../utils"
import { signOut } from "firebase/auth"
// import { useAuthState } from "react-firebase-hooks/auth"
import { useTranslation } from "react-i18next"

const ViewProfile = ({ onEdit }: any) => {
  const [user, setUser]: any = useState({})
  //   const [user, loading] = useAuthState(auth)

  const { t } = useTranslation()

  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"))

  const handleLogout = () => {
    signOut(auth)
      .then(() => {
        console.log("User logged out")
      })
      .catch((error) => {
        console.error("Error logging out: ", error)
      })
  }

  const handleDeleteAccount = async () => {
    // await userStore.deleteUser()
  }

  if (!user) {
    return <div>{t("loading")}...</div>
  }

  return (
    <Card>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
        <CardMedia
          component="img"
          image={user.profileImageUrl}
          alt={t("Profile")}
          sx={{
            width: isSmallScreen ? 100 : 140,
            height: isSmallScreen ? 100 : 140,
            borderRadius: "50%",
          }}
        />
      </Box>
      <UserPoints
        complete
        className="w-full flex-wrap p-1"
        style={{}}
        size={20}
        iconColor={undefined}
        iconStyle={{}}
        showMinDigits={false}
        precision={0}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {user.name}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {user.email}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>{t("phone")}:</strong> {user.phoneNumber}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>{t("address")}:</strong> {getLocationStr(user.userAddress)}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>{t("language")}:</strong> {user.language}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>{t("location")}:</strong> {user.location}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>{t("pushNotification")}:</strong> {user.pushNotifications}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          <strong>{t("currency")}:</strong> {user.currency}
        </Typography>
      </CardContent>
      <Box sx={{ display: "flex", justifyContent: "center", pb: 2 }}>
        <Button variant="contained" color="primary" onClick={onEdit}>
          {t("profile.editProfile")}
        </Button>
      </Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", p: 2 }} className="gap-2">
        <Button variant="contained" color="warning" onClick={handleLogout}>
          {t("profile.logout")}
        </Button>
        <Button variant="contained" color="error" onClick={handleDeleteAccount}>
          {t("profile.deleteAccount")}
        </Button>
      </Box>
    </Card>
  )
}

export default ViewProfile
